import React from "react";
import { cn } from "@/utils/cn";

export interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  internalScroll?: boolean;
}

export function PageContainer({
  children,
  className,
  style,
  internalScroll = false,
}: PageContainerProps) {
  return (
    <div
      style={style}
      className={cn(
        "mt-6 mb-4 flex flex-col rounded-2xl border border-white bg-white p-2 shadow-light md:mt-4 lg:mb-6 dark:border-gray-800 dark:bg-gray-800 dark:shadow-dark",
        internalScroll ? "flex-1 overflow-hidden" : "flex-1 overflow-auto",
        className,
      )}
    >
      {children}
    </div>
  );
}
